var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "c-default-overlay is-active" }, [
    _c(
      "button",
      {
        staticClass: "close-button c-overlay-close-button",
        attrs: { "aria-label": "Close alert", type: "button" },
        on: { click: _vm.closeStorageBoxReveal }
      },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "c-default-overlay-wrapper" },
      [
        _c("h2", { staticClass: "c-heading-large" }, [
          _vm._v(_vm._s(_vm.translate("frontend.js.storage_box.heading")))
        ]),
        _vm._v(" "),
        _c("storage-box", { on: { requestQuote: _vm.requestQuote } })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9ae2bbea", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9ae2bbea","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/frontend/vue/global/storage-boxes-reveal.vue
// module id = 241
// module chunks = 3